import React from 'react';
import styles from './Select.module.css';

const Select = ({ value, options, onChange, mixed, disabled }) => (
  <select
    className={`${styles.select} ${disabled ? styles.disabled : ''}`}
    value={mixed ? '' : value}
    onChange={(event) => onChange(event.target.value)}
    disabled={disabled}
  >
    {mixed && <option value="">Mixed</option>}
    {options.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>
);

export default Select;
